import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shipping-frame"
// Reloads the Entrega Turbo Frame with fresh shipping quotes whenever the
// destination CEP changes (cep-lookup dispatches "filled" for both the
// billing and shipping fields) or the same-as-billing toggle flips. Carries
// the currently checked shipping_service along so the reload can preserve it
// — the frame simply leaves it unchecked if the option is no longer offered.
export default class extends Controller {
	static targets = ["frame", "billingPostal", "shippingPostal", "sameAsBilling", "error"];
	static values = { url: String };

	reload() {
		if (!this.hasFrameTarget) return; // digital-only cart — no Entrega section
		this.dispatch("loading");

		const params = new URLSearchParams({
			billing_postal_code: this.billingPostalTarget.value,
			shipping_postal_code: this.shippingPostalTarget.value,
			shipping_same_as_billing: this.sameAsBillingTarget.checked ? "1" : "0",
		});
		const checked = this.frameTarget.querySelector('input[name="store_order[shipping_service]"]:checked');
		if (checked) params.set("shipping_service", checked.value);

		this.frameTarget.src = `${this.urlValue}?${params}`;
	}

	// A fetch that never lands leaves the previous quotes on screen with the
	// submit disabled by the `loading` event that opened the reload, and those
	// quotes belong to the OLD destination. Reveal the server-rendered
	// explanation and retry control inside the frame; payment stays disabled
	// until a reload actually lands, because only `turbo:frame-load` ->
	// shipping-totals#syncFromChecked can re-enable it from a fresh quote. A
	// still-checked radio carries the old CEP's token, so it must never be the
	// thing that re-enables the button.
	fetchError() {
		if (this.hasErrorTarget) this.errorTarget.hidden = false;
	}

	// A frame load that does land clears the message; the server re-renders it
	// hidden anyway, but a swap that kept an already-revealed line must not
	// leave it standing.
	frameLoaded() {
		if (this.hasErrorTarget) this.errorTarget.hidden = true;
	}
}
